// Historial de Estado de redes de la obra (R1, plan_migracion_reui.md §3 R1,
// fila «Historial de la obra» + Ajuste 18). Línea de tiempo de
// `obra_eventos` con @reui/timeline, composición TAL CUAL de c-timeline-11
// (https://reui.io/preview/base/components/c-timeline-11?ref=mcp) — sin los
// avatares del ejemplo: un evento de Estado de redes no tiene foto, solo el
// nombre de quien lo cargó (dato que no existe, no invención de estilo).
//
// Se exporta ({ historial }: { historial: EstadoRedesContexto['historial'] },
// contrato de R1 con R1-C/T5) para que el panel del Avivador lo reuse más
// adelante como su «Actividad», sin duplicar esta lógica.
//
// Sin scroll propio (regla §1.14, nunca un `max-h` a ojo): quien lo monta
// scrollea (hoy el <DialogContent> de estado-redes-dialog.tsx). Acá se ven
// los últimos 3 eventos y, si hay más, un Collapsible «Ver todo» revela el
// resto en el lugar (Ajuste 18).
import { useState } from 'react';
import {
  Timeline,
  TimelineContent,
  TimelineDate,
  TimelineHeader,
  TimelineIndicator,
  TimelineItem,
  TimelineSeparator,
} from '@/components/reui/timeline';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Button } from '@/components/ui/button';
import { fHora } from '@/components/rdt/rdt-domain';
import type { EstadoRedesContexto } from '@/types/api';

type EventoEstadoRedes = EstadoRedesContexto['historial'][number];

/** Eventos visibles antes de necesitar «Ver todo». */
const CANTIDAD_VISIBLE = 3;

function EventoHistorial({ evento }: { evento: EventoEstadoRedes }) {
  return (
    <TimelineItem step={1}>
      <TimelineHeader>
        <TimelineSeparator />
        <TimelineIndicator />
      </TimelineHeader>
      <TimelineContent>
        <p className="text-sm">
          <span className="font-medium">{evento.despues}</span>
          {evento.antes && <span className="text-muted-foreground"> antes {evento.antes}</span>}
        </p>
        <TimelineDate className="mt-0.5 mb-0">
          {evento.usuarioNombre} · {fHora(evento.creadoAt)}
        </TimelineDate>
        {evento.nota && <p className="mt-0.5 text-sm text-muted-foreground">{evento.nota}</p>}
      </TimelineContent>
    </TimelineItem>
  );
}

export function HistorialEstadoRedes({ historial }: { historial: EstadoRedesContexto['historial'] }) {
  const [verTodo, setVerTodo] = useState(false);

  if (historial.length === 0) {
    return <p className="m-0 text-[12px] text-text-tertiary">Antes de la app el estado se cargaba en SharePoint, sin historial.</p>;
  }

  const visibles = historial.slice(0, CANTIDAD_VISIBLE);
  const resto = historial.slice(CANTIDAD_VISIBLE);

  return (
    // Línea de tiempo de HECHOS ya ocurridos: todos cuentan como completados
    // (TimelineItem marca `data-completed` con step <= value), así el
    // indicador y el conector salen llenos, como en c-timeline-11.
    <Timeline value={1}>
      {visibles.map(evento => (
        <EventoHistorial key={evento.id} evento={evento} />
      ))}
      {resto.length > 0 && (
        <Collapsible open={verTodo} onOpenChange={setVerTodo}>
          <CollapsibleTrigger render={<Button type="button" variant="ghost" size="sm" className="ml-8" />}>
            {verTodo ? 'Ver menos' : 'Ver todo'}
          </CollapsibleTrigger>
          <CollapsibleContent>
            {resto.map(evento => (
              <EventoHistorial key={evento.id} evento={evento} />
            ))}
          </CollapsibleContent>
        </Collapsible>
      )}
    </Timeline>
  );
}
